import TokenInfo from "../models/token-info";
import { getToken, getUserInfo } from "../utils/auth-utils";
import { ProfileWebContent } from "../models/profile-web-content";
import ProfileDetails, { ProfileDetailsResponse } from "../models/profile-details";
import logger from "../utils/logs";

class UserProfileService {
  public constructor() { }

  serialize = function (obj: any) {
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        if (obj[p] != undefined && obj[p] != null && obj[p] != "") {
          str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        }
      }
    return str.join("&");
  };

  public async loadUserProfile(): Promise<ProfileDetailsResponse | { error: string; status: number }> {
    try {
      const userInfo = getUserInfo() as TokenInfo;
      
      if(!userInfo.uuid || !userInfo.type) {
        return { error: "user not logined", status: 401 };
      }

      const response = await fetch(`/api/auth/v1/profile/${userInfo.uuid}/${userInfo.type}`, {
        method: "GET",
        headers: {
          Authorization: getToken(),
        },
       //next: { revalidate: 10 } ,
       //cache: 'force-cache'
      });

      if (!response.ok) {
        return { 
          error: `Failed to load user profile: ${response.status} ${response.statusText}`, 
          status: response.status 
        };
      }

      const data = await response.json();
      return data as ProfileDetailsResponse;
    } catch (error) {
      return { 
        error: error instanceof Error ? error.message : "Unknown error occurred while loading user profile", 
        status: 500 
      };
    }
  }
   
 

  async uploadFile(files: File[], token: string, type: string | undefined) {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var formdata = new FormData();
    files.forEach((file) => {
      formdata.append("files", file);
    });

    var requestOptions: RequestInit = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    const result = await fetch(
      `/api/auth/v1/docs/upload?${type ? "type=" + type : ""}`,
      requestOptions
    );

    return result;
  }

  async uploadFileAsBlob(data: any, token: string, type: string | undefined) {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    const formData = new FormData();
    formData.append("files", new File([data], data.name));
    var requestOptions: RequestInit = {
      method: "POST",
      headers: myHeaders,
      body: formData,
      redirect: "follow",
    };

    const result = await fetch(
      `/api/auth/v1/docs/upload?${type ? "type=" + type : ""}`,
      requestOptions
    );

    return result;
  }

  async uploadBanner(data: any, token: string) {
    return this.uploadFileAsBlob(data, token, "BANNER");
  }

  async uploadGallery(files: File[], token: string) {
    return this.uploadFile(files, token, "GALLERY");
  }

  public getProfileContent() {
    return fetch(`/api/manage/v1/content/web`, {
      method: "GET",
      headers: {
        Authorization: getToken(),
      },
    });
  }

  public postProfileContent(data: ProfileWebContent) {
    return fetch(`/api/manage/v1/content/web`, {
      method: "POST",
      headers: {
        Authorization: getToken(),
      },
      body: JSON.stringify(data),
    });
  }

  public logout( ) {
    var Cookies = document.cookie.split(";");
    // set 1 Jan, 1970 expiry for every cookies
    for (var i = 0; i < Cookies.length; i++) {
      document.cookie = Cookies[i] + "=;expires=" + new Date(0).toUTCString();
    }
    return fetch("/api/auth/v2/logout",{
      method: "GET",
      headers: {
        Authorization: getToken(),
      }});

  }


  public async upsertProfile(profile: ProfileDetails): Promise<ProfileDetailsResponse | Error> {
    try {
      const userInfo = getUserInfo() as TokenInfo;
      const response = await fetch(`/api/auth/v1/profile`, {
        method: "POST",
        headers: {
          Authorization: getToken(),
          //"Content-Type": "application/json",
        },
        body: JSON.stringify(profile),
      });

      if (!response.ok) {
        return new Error(`Failed to load user profile: ${response.status} ${response.statusText}`);
      }

      const data = await response.json();
      return data as ProfileDetailsResponse;
    } catch (error) {
      return error instanceof Error ? error : new Error("Unknown error occurred while loading user profile");
    }
  }
}



export default new UserProfileService();
